import { gsap } from "gsap";
import React, { useEffect, useRef, useState } from "react";

import "./confidence.css";
// assets:
import imgTwo from "./images/img-2.png";
import imgFour from "./images/img-4.png";
import imgFive from "./images/img-5.png";
import videoSanya from "./images/Sanya-1.mp4";

export default function Confidence() {
  let imageRightCol = useRef(null);
  let imageLeftCol = useRef(null);
  let textIntroCol = useRef(null);
  let imageCenterCol = useRef(null);
  let imageCenterCol2 = useRef(null);
  function scrollToTop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
    // window.scrollTo(0,0)
  }
  useEffect(() => {
    scrollToTop();
  });
  useEffect(() => {
    // gsap.from(imageRightCol, {
    //   y: "-80px",
    //   opacity: 0,
    //   //stagger: 0.2,
    //   duration: 1.2,
    //   scale: 1,
    //   // ease: "power4.inOut",
    //   delay: 0.1
    // });
    gsap.from(imageLeftCol, {
      y: "-80px",
      opacity: 0,
      //stagger: 0.2,
      duration: 1.2,
      scale: 1,
      //ease: "power4.inOut",
      delay: 0.1
    });
    gsap.from(textIntroCol, {
      y: "-80px",
      opacity: 0,
      //stagger: 0.2,
      duration: 1.2,
      scale: 1,
      //ease: "power4.inOut",
      delay: 0.1
    });
    // gsap.from(imageCenterCol, {
    //   y: "-80px",
    //   opacity: 0,
    //   //stagger: 0.2,
    //   duration: 1.2,
    //   scale: 1,
    //   //ease: "power4.inOut",
    //   delay: 0.1
    // });
    gsap.from(imageCenterCol2, {
      y: "-50px",
      opacity: 0,
      //stagger: 0.2,
      duration: 1.2,
      scale: 1,
      //ease: "power4.inOut",
      delay: 0.1
    });
  }, []);

  return (
    <div className="confidence-wrapper">
      <section className="section1 confidence">
        <h2 className="mobile-reveal">Naturalete</h2>

        <div className="equal-col col1">
          <div ref={(el) => (textIntroCol = el)} className="col-5 equal-col">
            <div className="col-6">
              <h2 className="mobile-erase">Naturalete</h2>
              <p>
                {" "}
                Linii geometrice și nuanțe de aur în bijuterii create pentru
                tine și vara ta.
              </p>
              <div className="cta-colectie mobile-erase">
                {" "}
                <a
                  href={
                    "https://www.teilor.ro/category/urbanima?page=1&sortBy=newest&layout=standard&refinementList%5Bro_categories.lvl1%5D%5B0%5D=Bijuterii%20%3E%20Cercei"
                  }
                >
                  <div className="button1"> DESCOPERĂ CERCEII </div>
                </a>
              </div>
            </div>
            <div className="col-7">
              <div className="col-1">
                <a
                  href={
                    "https://www.teilor.ro/product/55427/Cercei-tortite-cu-charmuri-din-aur-galben-de-14K"
                  }
                >
                  <img
                    ref={(el) => (imageRightCol = el)}
                    className="zoom"
                    src="https://cdn.media.amplience.net/i/teilor/cerceitortitecucharmuridinaurgalbende14k_19241_1_1612361024"
                    alt="Cercei tortite cu charmuri din aur galben de 14K"
                  />
                </a>
              </div>
              <div className="col-1">
                <img ref={(el) => (imageLeftCol = el)} src={imgTwo} alt="" />
              </div>
            </div>
          </div>
          <div className="col-1 mobile-reveal">
            <div className="cta-colectie">
              {" "}
              <a href="https://www.teilor.ro/category/urbanima?page=1&sortBy=newest&layout=standard&refinementList%5Bro_categories.lvl1%5D%5B0%5D=Bijuterii%20%3E%20Cercei">
                <div className="button1"> DESCOPERĂ CERCEII </div>
              </a>
            </div>
          </div>
          <div className="col-3">
            <div className="col-1">
              <div className="col-1">
                <video className="videoAntonia" playsInline autoPlay loop muted>
                  <source
                    src="https://cdn.media.amplience.net/v/teilor/Sanya-1/mp4_720p"
                    type="video/mp4"
                  />
                </video>
              </div>
              <div className="col-2">
                <a href="https://www.teilor.ro/product/55429/Cercei-banuti-cu-inimioare-din-aur-galben-de-14K">
                  <img
                    ref={(el) => (imageCenterCol = el)}
                    className="zoom"
                    src="https://cdn.media.amplience.net/i/teilor/cerceibanuticuinimioaredinaurgalbende14k_19243_1_1612361026"
                    alt="Cercei banuti cu inimioare din aur galben de 14K"
                  />
                </a>
              </div>
              <div className="col-2">
                <img
                  ref={(el) => (imageCenterCol2 = el)}
                  src={imgFour}
                  alt=""
                />
              </div>
            </div>
          </div>

          <div className="col-4">
            <div className="col-1">
              <img src={imgFive} alt="" />
            </div>
            <div className="col-1">
              <a
                href={
                  "https://www.teilor.ro/product/1781/Cercei-din-aur-galben-de-14K"
                }
              >
                <img
                  className="zoom"
                  src="https://cdn.media.amplience.net/i/teilor/_16233_1_1608131981"
                  alt="Cercei din aur galben de 14K"
                />{" "}
              </a>{" "}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
